import { render } from "./SubrogationList.vue?vue&type=template&id=52add1ff&scoped=true"
import script from "./SubrogationList.vue?vue&type=script&lang=js"
export * from "./SubrogationList.vue?vue&type=script&lang=js"

import "./SubrogationList.vue?vue&type=style&index=0&id=52add1ff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52add1ff"]])

export default __exports__